import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {AboutDTO} from '../models/AboutDTO';

@Injectable({
  providedIn: 'root'
})
export class AboutService {

  private url = environment.baseUrl + '/about'; 

  constructor(private httpClient: HttpClient) {
  }

  getLatest(): Observable<AboutDTO> {
    return this.httpClient.get<AboutDTO>(this.url);
  }
}
